export default "__VITE_PUBLIC_ASSET__052fa620__"